import { render, staticRenderFns } from "./handItemform.vue?vue&type=template&id=bb2830d8"
import script from "./handItemform.vue?vue&type=script&lang=js"
export * from "./handItemform.vue?vue&type=script&lang=js"
import style0 from "./handItemform.vue?vue&type=style&index=0&id=bb2830d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports